module.exports = __webpack_public_path__ + "static/img/bg_benefit_s_com_card.59ea50f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_benefit_s_com_card.png
// module id = Yjy6
// module chunks = 0